import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { WelcomeDefaultTariffSplashProps } from './WelcomeDefaultTariffSplash.types';

export const renderWelcomeDefaultTariffSplash = ({ onClose, ...data }: WelcomeDefaultTariffSplashProps) =>
    openPopupHelper({ popupName: popupNames.WELCOME_DEFAULT_TARIFF_SPLASH, data, onClose });
